function imposeMinMax(el, cvs){
  if(el.value != ""){
    if(parseInt(el.value) < parseInt(el.min)){
      el.value = el.min;
    }
    if(parseInt(el.value) > parseInt(el.max)){
      el.value = el.max;
//      $('.current-variant-stock').css("display", "block");
      $(cvs).css("display", "block");
    }
    else {
//      $('.current-variant-stock').css("display", "none");
      $(cvs).css("display", "none");
    }
  }
  
  if(el.max==0){
   $(el).next().addClass("display-cart-sold-out");
  } else {
   $(el).next().removeClass("display-cart-sold-out");
  }

}

function addItemToCart(variant_id, quantity) {
	data = {
		"quantity": quantity,
		"id": variant_id
	}
	jQuery.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: data,
		dataType: 'json',
		success: function(response) { 
          	location.reload();
		}
	});   
}


function itemAddedQty() {
  var invqty = $("#Quantity").attr("max");

  let cart = $.getJSON('/cart.js');
    cart.done(function(){
	    cart = cart.responseJSON;
	    let items = cart.items;

		for(var i = 0; i < items.length; i++){
        	if (items[i].product_id == $('.cart-item-display').attr('data-id')) {
				$('.cart-item-display').addClass('item-added');     
				$('.added-quality-num').text(items[i].quantity);
              	
              if (items[i].quantity == invqty) {
                $(".product-single__cart-submit-wrapper").css("display", "none");
              }
        	}
      	}
		$('.mobile-cart-counter').html(cart.item_count);
      	$('.large-cart-counter').html(cart.item_count);
    })
}


function collectionPageItemAddedQty() {
  
  let cart = $.getJSON('/cart.js');
    cart.done(function(){
	    cart = cart.responseJSON;
	    let items = cart.items;

		for(var i = 0; i < items.length; i++){
			var $parentitem = $('[data-id="' + items[i].product_id + '"]');
			var invqty = $parentitem.find("#Quantity").attr("max");

			$parentitem.addClass('item-added');     
			$parentitem.find('.added-quality-num').text(items[i].quantity);
              	
              if (items[i].quantity == invqty) {
                $(".product-single__cart-submit-wrapper").css("display", "none");
              }
			  $('.mobile-cart-counter').html(cart.item_count);
			  $('.large-cart-counter').html(cart.item_count);
      	}
    })
}

$(document).ready(function() {

  /*** POPUP WINDOW ***/
  var exs_popup_show = sessionStorage.getItem('exspopup');
  if(exs_popup_show != 'shown'){
      $duration = 5;
      $('.seconds').text($duration);
      $('.exs-popup-wrapper').fadeIn(1500);
  //    $myTimer = setInterval(function(){ startTimer() }, 1000);
      $('.exs-popup .exs-popup-btn-close').on("click",function(){
  //      clearInterval($myTimer);
        $('.exs-popup-wrapper').fadeOut(500);
      });
      sessionStorage.setItem('exspopup','shown');
  
      function startTimer(){
        $duration--;
        $('.seconds').text($duration);
        if($duration==0){
          clearInterval($myTimer);
          $('.exs-popup-wrapper').fadeOut(500);
        }
      }
  }

  /* Ajax cart on collection page for Add button */
  $('.add2cart__collection--button').on('click', function(evt) {
    evt.preventDefault();
    var $addToCartBtn = $(this),
      $addToCartForm = $(this).closest('form'),
      $addToCartText = $(this).find('span');
    if ($addToCartForm.length) {
      $addToCartBtn
        .data('add-to-cart', $addToCartText.text())
        .prop('disabled', true)
        .addClass('btn--ajax-disabled');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function() {
          // reupdate cart count
          theme.afterCartLoad();
          $addToCartBtn.prop('disabled', false);
          $addToCartBtn.removeClass('btn--ajax-disabled');
          collectionPageItemAddedQty();
        },
        error: function(XMLHttpRequest) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--ajax-disabled');
          if (status === 422) {
            $addToCartText.text(theme.strings.soldOut);
          } else {
            $addToCartBtn.prop('disabled', false);
            $addToCartText.text($addToCartBtn.data('add-to-cart'));
          }
          $addToCartBtn.after('<p class="errors">' + response + '</p>');
        }
      });
    }
  });
});